var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51613 12.6411L14.375 17.5C15.2379 18.3629 16.6371 18.3629 17.5 17.5C18.3629 16.6371 18.3629 15.2379 17.5 14.375L12.6027 9.47774M9.51613 12.6411L11.5962 10.1153C11.8596 9.79551 12.2118 9.59433 12.6027 9.47774M9.51613 12.6411L5.63693 17.3516C5.23364 17.8413 4.63247 18.125 3.99807 18.125C2.82553 18.125 1.875 17.1745 1.875 16.0019C1.875 15.3675 2.1587 14.7664 2.64842 14.3631L8.34551 9.67134M12.6027 9.47774C13.0606 9.34119 13.5715 9.32067 14.0549 9.36153C14.1604 9.37045 14.2672 9.375 14.375 9.375C16.4461 9.375 18.125 7.69607 18.125 5.625C18.125 5.07478 18.0065 4.55223 17.7936 4.08149L15.0635 6.81164C14.1338 6.59821 13.4019 5.86636 13.1885 4.93664L15.9187 2.20645C15.4479 1.99353 14.9253 1.875 14.375 1.875C12.3039 1.875 10.625 3.55393 10.625 5.625C10.625 5.73282 10.6295 5.83958 10.6385 5.94509C10.7142 6.8413 10.579 7.83201 9.88471 8.40377L9.79965 8.47382M8.34551 9.67134L4.92417 6.25H3.75L1.875 3.125L3.125 1.875L6.25 3.75V4.92417L9.79965 8.47382M8.34551 9.67134L9.79965 8.47382M15.3125 15.3125L13.125 13.125M4.05603 15.9375H4.06228V15.9438H4.05603V15.9375Z",
    stroke: "#002244",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgUtilities);
export default __webpack_public_path__ + "static/media/svg_utilities.89103d2bae231894df2c0cde027f7aed.svg";
export { ForwardRef as ReactComponent };